module.exports = __webpack_public_path__ + "static/media/clipboard.c9aef99a.svg";